import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { poDisclaimerRepository } from '@webapp/modules/purchasing/data-access/repositories/PODisclaimerRepository'
import { poDisclaimerLabelQueryConfig } from '@webapp/modules/purchasing/query-configs/poDisclaimerLabel'

export const useMutateDeletePODisclaimerLabel = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, number>({
    mutationFn: (id: number) => poDisclaimerRepository.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: poDisclaimerLabelQueryConfig.all().queryKey,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
